import React from "react";
import { TRANSACTION_TYPES } from "../utils/constants";

const TransactionDetails = ({ storeData, totalNet, totals, voidTotals }) => {
  const currencyFormatter = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div
      style={{
        paddingLeft: "20px",
        backgroundColor: "white",
        borderRadius: "5px",
      }}
    >
      {TRANSACTION_TYPES.map((type) => {
        const typeData = storeData[type] || {};
        const netSale = typeData.netSale || 0;
        const transactionCount = typeData.tc || 0;
        const percentageOfTotal = totalNet > 0 ? (netSale / totalNet) * 100 : 0;

        return (
          <>
            <div className="row" key={type}>
              <div className="col-3">
                <strong style={{ color: "#83c14a" }}>{type}:</strong>{" "}
                {currencyFormatter.format(netSale)}
              </div>
              <div className="col-3">
                <strong style={{ color: "#83c14a" }}>Transaction Count:</strong>{" "}
                {transactionCount}
              </div>
              <div className="col-3">
                <strong style={{ color: "#83c14a" }}>Percentage:</strong>{" "}
                {isNaN(percentageOfTotal)
                  ? "0%"
                  : `${percentageOfTotal.toFixed(2)}%`}
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default TransactionDetails;
